import React, { useEffect, useState } from "react";
import { opsPageSteps, STEPLISTSIDENAVMAP } from "./OPSPageInfo";
import * as rolePermConsts from "../../../../constants/RolePermissionConstants";
import * as OPSConstants from "./OPSConstants";
import * as _ from "../../../../constants/Constants";
import { Row, Col, Button } from "react-bootstrap";
import UPSAddressModal from "../UPSAccount/UPSAddressModal";
import { DisplayVendorStatus, Status, TextArea } from "./helpers";
import { getUserRolePermission } from "../../../../utils/rolePermissionAccess";
import SavedUPSAccount from "./UPSAccount/SavedUPSAccount";
import UPSClosureDates from "./UPSAccount/UPSClosureDates";
import ErrorContainer from "../../../Common/Errors/ErrorContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  httpGetThreeNotesByProfileId,
  httpPostSaveVendorStatusByProfileId,
  httpGetVendorStatusDetails,
} from "../../../../service/httpClient";
import { updateCommonInfo } from "../../../../redux/commonSlice";
import { updateServiceData } from "../../../../redux/serviceSlice";
import { convertDateAsUTC } from "../../../../utils/DateUtility";
import { extractVendorStatus } from "../../OnboardingContainer";
import Cookie from "js-cookie";

const getDateInDDMMYYYY = (d) => {
  var DateToConvert = d;

  var dd = DateToConvert.getDate();
  var mm = DateToConvert.getMonth() + 1; //January is 0!

  var yyyy = DateToConvert.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  var result = mm + "/" + dd + "/" + yyyy;
  return result;
};

const getClosureDates = (closureDates) =>
  closureDates?.length
    ? closureDates.map((d, i) => {
        const date = convertDateAsUTC(d);
        return {
          key: i,
          date,
          label: getDateInDDMMYYYY(date),
        };
      })
    : [];

const getStatusByStatusId = (vendorStatus, pageInfo) => {
  const statusId = pageInfo.statusId;
  let currentSaveStatus = {};
  let pageStatus = {};
  let predefinedNotes = {};
  let currentPageStatus = {};
  if (vendorStatus && vendorStatus.length) {
    vendorStatus.length &&
      vendorStatus.forEach((status) => {
        if (status.vendorStatus) {
          const id = status?.vendorStatus?.statusId;
          const statusValue = status.vendorStatus.lastStatusUpdatedValue;
          const predefinedNote = status.predefinedNotes;
          if (id === statusId) {
            currentSaveStatus = { ...status.vendorStatus };
            currentPageStatus = statusValue;
          }

          pageStatus = { ...pageStatus, [id]: statusValue };
          predefinedNotes = {
            ...predefinedNotes,
            [id]:
              id === statusId && statusValue !== OPSConstants.PENDING
                ? null
                : predefinedNote,
          };
        }
      });

    return {
      currentSaveStatus,
      pageStatus,
      predefinedNotes,
      currentPageStatus,
    };
  }
};

const OPSWorkflow = ({ step, roleName, isMPVendor }) => {
  const pageInfo = opsPageSteps[step];
  const dispatch = useDispatch();
  const store = useSelector(({ service, common }) => ({
    vendorStatus: service.vendorStatus,
    vendorProfile: service.vendorProfile,
    boardingStatuses: common.boardingStatuses,
    userEmail: common.userEmail,
    currentUserName: service.roles?.userName,
    upsAccountAddress: service.vendorProfile?.upsAccountAddress || [],
    rtvAddress: service.vendorProfile?.rtvAddress || [],
    vendorDetails: service.vendorProfile?.vendorDetail,
  }));

  const [state, setState] = useState({
    isClosureDateChanged: false,
    showUPSAddressModal: false,
    isMerchantApproved: store.vendorDetails?.status === _.APPROVED,
    isStatusChanged: false,
    customComment: "",
    validationMsg: "",
    changedStatusName: "",
    isCustomMsgRequired: false,
    rolePermissionStatus: rolePermConsts.NONE,
    validationMsg: "",
    nationalHolidayIdentifier: store.vendorDetails?.nationalHolidayIdentifier,
    upsClosureDates: getClosureDates(store.vendorDetails?.upsClosureDates),
    ...getStatusByStatusId(store?.vendorStatus, pageInfo),
  });

  useEffect(() => {
    setUserAccess();
  }, []);

  const toggleUPSAddressModal = () =>
    setState((state) => ({
      ...state,
      showUPSAddressModal: !state.showUPSAddressModal,
    }));

  const updateUPSAddresses = (upsAccountAddress) =>
    dispatch(
      updateServiceData({
        vendorProfile: { ...store.vendorProfile, upsAccountAddress },
      })
    );

  const upsAddressInfo = () => ({
    upsAccountAddress: store.upsAccountAddress,
    duns: store.vendorDetails?.duns,
    userEmail: store.userEmail,
  });

  const getActiveOPSWorkflowPage = () => {
    switch (pageInfo.statusName) {
      case _.UPLOAD_CONTRACT_ID:
        return rolePermConsts.VENDORPLATFORM_PREBOARDING_REVIEWCONTRACT;
      case _.UPS_ACCOUNT_ID:
        return rolePermConsts.VENDORPLATFORM_PREBOARDING_UPSACCOUNT;
      case _.UPLOAD_PACKING_SLIP_ID:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_PACKINGSLIP;
      case _.UPLOAD_SHIPPING_LABEL_ID:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_SHIPPINGLABEL;
      case _.ORDER_TESTING_ID:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_ORDERTESTING;
      case _.TESTING_846_ID:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_846TESTING;
      case _.BOSS_AGREEMENT:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_BOSSAGREEMENT;
      case _.TABLE_SETUP:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_TABLESETUP;
      case _.QUALITY_LEADER_APPROVAL:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_QUALITYLEADERAPPROVAL;
      case _.EVP_AND_ERP_SETUP:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_EVPANDERPSETUP;
      case _.ITEM_SKU_SETUP:
        return rolePermConsts.VENDORPLATFORM_INTEGRATION_ITEMSKUSETUP;
      case _.COMPLETE_VLL_ID:
        return rolePermConsts.VENDORPLATFORM_PUBLISH_COMPLETEVLL;
      case _.PAGE_COMPLETE_ID:
        return rolePermConsts.VENDORPLATFORM_PUBLISH_PAGECREATIONCOMPLETE;
      case _.ONBOARDING_COMPLETE_ID:
        return rolePermConsts.VENDORPLATFORM_PUBLISH_ONBOARDINGCOMPLETE;
      case _.LIVE_ID:
        return rolePermConsts.VENDORPLATFORM_PUBLISH_LIVE;
      default:
        break;
    }
  };

  const setUserAccess = () => {
    let rolePermissionStatus;
    const permission = getUserRolePermission(
      getActiveOPSWorkflowPage(),
      rolePermConsts.ALL
    );

    if (permission === rolePermConsts.NONE) {
      rolePermissionStatus = rolePermConsts.NONE;
    } else {
      rolePermissionStatus = permission;
    }
    setState((state) => ({
      ...state,
      rolePermissionStatus,
      prevState: { ...state, rolePermissionStatus },
    }));
  };

  const disablePage = () => {
    let merchantAllowed = ["2", "13", "14", "15", "16"].includes(step);

    if (state.rolePermissionStatus !== rolePermConsts.EDIT) {
      return true;
    } else if (
      !state.isMerchantApproved ||
      store.boardingStatuses?.[_.DVN_SET_UP_ID] !== _.APPROVED ||
      roleName === _.EXTERNAL_VENDOR_GENERIC ||
      roleName === _.EXTERNAL_GENERIC_ADMIN ||
      (!merchantAllowed &&
        roleName === _.ROLE_OMNI_MERCHANT &&
        (STEPLISTSIDENAVMAP[step] === _.VP_MA_SB_INT_HEAD ||
          STEPLISTSIDENAVMAP[step] === _.VP_MA_SB_PB_HEAD)) ||
      (state.rolePermissionStatus !== rolePermConsts.EDIT &&
        (STEPLISTSIDENAVMAP[step] === _.VP_MA_SB_PB_HEAD ||
          pageInfo.statusName === _.ONBOARDING_COMPLETE_ID))
    ) {
      return true;
    }

    return false;
  };

  const showGrid = (fieldType, isPredefStatusExist) => {
    let fieldStyle = "";
    if (fieldType === "radio") {
      fieldStyle =
        pageInfo.statusName === OPSConstants.ORDER_TESTING
          ? "col-md-3 genericTextColor"
          : "col-md-4 genericTextColor";
    } else if (fieldType === "checkbox") {
      fieldStyle =
        pageInfo.statusName === OPSConstants.ORDER_TESTING
          ? isPredefStatusExist
            ? "col-md-3 subStatusDisable"
            : "col-md-3"
          : isPredefStatusExist
          ? "col-md-4 subStatusDisable"
          : "col-md-4";
    }

    return fieldStyle;
  };

  const getActualStatus = (value) => {
    if (value === OPSConstants.COMPLETE) {
      return OPSConstants.APPROVED;
    } else if (value === OPSConstants.IN_PROCESS) {
      return OPSConstants.PENDING;
    } else {
      return OPSConstants.NOT_STARTED;
    }
  };

  const getDisplayStatus = (value) => {
    if (value === OPSConstants.APPROVED) {
      return OPSConstants.COMPLETE;
    } else if (value === OPSConstants.PENDING) {
      return OPSConstants.IN_PROCESS;
    } else {
      return OPSConstants.NOT_STARTED;
    }
  };
  const getSelectedStatus = (pageValue, statusId, fieldType) => {
    let flag = false;
    if (fieldType === "radio") {
      if (
        !state.pageStatus?.[statusId] &&
        pageValue === OPSConstants.NOT_STARTED
      ) {
        flag = true;
      } else {
        state.pageStatus &&
          Object.keys(state.pageStatus).forEach((key) => {
            if (
              Number(key) === statusId &&
              state.pageStatus[key] === getActualStatus(pageValue)
            )
              flag = true;
          });
      }
      return flag;
    } else if (fieldType === "checkbox") {
      const showCheckedValue =
        getDisplayStatus(state.pageStatus?.[pageInfo.statusId]) ===
        OPSConstants.IN_PROCESS;
      Object.keys(state.predefinedNotes).forEach((key) => {
        if (
          showCheckedValue &&
          Number(key) === statusId &&
          state.predefinedNotes[key] === pageValue
        )
          flag = true;
      });
      return flag;
    }
  };

  const onChangeHolidayIdentifier = () =>
    setState((state) => ({
      ...state,
      nationalHolidayIdentifier: !state.nationalHolidayIdentifier,
      isClosureDateChanged: true,
    }));

  const onChangeClosureDates = (date) => {
    let oldDateObjArr = [...state.upsClosureDates].map((x) => x.date);
    if (oldDateObjArr.length < 20) {
      oldDateObjArr.push(date);
      let newDateArr = oldDateObjArr.map((d, i) => ({
        key: i,
        label: getDateInDDMMYYYY(d),
        date: d,
      }));

      setState((state) => ({
        ...state,
        upsClosureDates: [...newDateArr],
        isClosureDateChanged: true,
      }));
    }
  };
  const onDeleteClosureDate = (dateToDelete) => () => {
    setState((state) => ({
      ...state,
      upsClosureDates: [...state.upsClosureDates].filter(
        (date) => date.key !== dateToDelete.key
      ),
      isClosureDateChanged: true,
    }));
  };

  const onCancel = () =>
    setState((state) => ({ ...state.prevState, prevState: state.prevState }));

  const onSetCustomMsg = (event) => {
    let value = event.target.value;
    setState((state) => {
      return {
        ...state,
        customComment: value,
        isCustomMsgRequired: !value,
        validationMsg: "",
        isStatusChanged: true,
      };
    });
  };

  const onStatusChange = (event, statusId) => {
    event.persist();
    setState((state) => ({
      ...state,
      validationMsg: "",
      isStatusChanged: true,
    }));

    const value = event.target.defaultValue;
    const actualStatus = getActualStatus(value);
    if (event.target.name.indexOf("generic") > -1) {
      setState((state) => {
        const noteValue =
          actualStatus !== _.PENDING ? null : state.predefinedNotes[statusId];
        return {
          ...state,
          isStatusChanged: true,
          changedStatusName: value,
          pageStatus: { ...state.pageStatus, [statusId]: actualStatus },
          predefinedNotes: {
            ...state.predefinedNotes,
            [statusId]: noteValue,
          },
          isCustomMsgRequired: true,
          currentSaveStatus: {
            ...state.currentSaveStatus,
            lastStatusUpdatedValue: actualStatus,
            subStatus: noteValue,
          },
        };
      });
    } else {
      const targetValue = event.target.value;
      const checked = event.target.checked;

      setState((state) => ({
        ...state,
        formValidated: true,
        currentSaveStatus: {
          ...state.currentSaveStatus,
          subStatus: checked ? targetValue : null,
        },
        changedStatusName: OPSConstants.IN_PROCESS,
        predefinedNotes: {
          ...state.predefinedNotes,
          [statusId]: checked ? targetValue : null,
        },
        isCustomMsgRequired: state.customComment || checked ? false : true,
        validationMsg: "",
      }));
    }
  };

  const updateStatusDetails = () => {
    setState((state) => ({
      ...state,
      isStatusChanged: false,
    }));

    let formValidated = true;

    if (
      isMPVendor &&
      state.currentPageStatus === OPSConstants.APPROVED &&
      pageInfo.statusId === OPSConstants.LIVE_STATUS_ID
    ) {
      formValidated = false;
      setState((state) => ({
        ...state,
        validationMsg: OPSConstants.LIVE_ERR_MSG,
      }));
    } else if (
      state.changedStatusName === OPSConstants.NOT_STARTED &&
      !state.customComment.trim()
    ) {
      formValidated = false;
      setState((state) => ({
        ...state,
        validationMsg: OPSConstants.CUSTOM_ERR_MSG,
      }));
    } else if (
      state.changedStatusName === OPSConstants.IN_PROCESS &&
      state.isCustomMsgRequired &&
      !state.customComment.trim()
    ) {
      formValidated = false;
      setState((state) => ({
        ...state,
        validationMsg: OPSConstants.CUSTOM_PRENOTES_ERR_MSG,
      }));
    }

    const userEmail = Cookie.get("email")
      ? Cookie.get("email").toLowerCase()
      : "";

    if (formValidated) {
      let data = {
        vendorStatus: {
          ...state.currentSaveStatus,
          lastStatusUpdatedBy: userEmail,
          lastUpdatedBy: userEmail,
        },
        statusName: pageInfo.statusName,
        comments: state.customComment,
        updatedByFullName: store.currentUserName,
        upsClosureDates: state.upsClosureDates.map((d) => d.date),
        nationalHolidayIdentifier: state.nationalHolidayIdentifier,
        //SVH-2038 add to get current user email to set lastupdatedby field
        userEmail,
      };

      httpPostSaveVendorStatusByProfileId(data)
        .then(async (response) => {
          const profileId = store.vendorDetails?.id.toString();
          const notes = await httpGetThreeNotesByProfileId(profileId);
          const vendorStatus = await httpGetVendorStatusDetails(profileId);
          const { mutatedVendorStatus } = extractVendorStatus(
            store.vendorDetails.status,
            vendorStatus.data
          );

          dispatch(
            updateServiceData({
              notes: notes.data,
              vendorStatus: vendorStatus.data,
            })
          );
          dispatch(
            updateCommonInfo({
              boardingStatuses: mutatedVendorStatus,
            })
          );
          setState((state) => ({
            ...state,
            customComment: "",
            isStatusChanged: false,
            changedStatusName: "",
            isCustomMsgRequired: false,
            isClosureDateChanged: false,
            validationMsg: "",
            currentPageStatus: state.pageStatus[pageInfo.statusId],
          }));
        })
        .catch((error) => {
          console.log(error);
          setState((state) => ({
            ...state,
            validationMsg: OPSConstants.SUBMIT_ERROR,
          }));
        });
    }
  };
  const disableElement = disablePage();
  const disablePreDefinedNotes =
    getDisplayStatus(state.pageStatus?.[pageInfo.statusId]) !== _.IN_PROCESS;

  const getDisableStatus =
    state.isClosureDateChanged || state.isStatusChanged ? false : true;

  if (state.rolePermissionStatus === rolePermConsts.NONE) {
    return (
      <div>
        <ErrorContainer
          errorMsg={
            rolePermConsts.VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART1 +
            pageInfo.stepTitle +
            rolePermConsts.VMP_COMMON_PAGE_ACCESS_ERROR_MSG_PART2
          }
          errorStatus={state.rolePermissionStatus}
          errorStyle="errorMessage"
        />
      </div>
    );
  }

  if (isMPVendor && pageInfo.stepOrder === "17") {
    return (
      <Row>
        <Col>
          {store.upsAccountAddress.length > 0 && (
            <SavedUPSAccount
              addressList={store.upsAccountAddress}
              step={step}
              merchandiseType={store.vendorDetails?.merchandiseType}
            />
          )}
          
          {store.rtvAddress.fedexAccountNumber && (
            <SavedUPSAccount
              rtvAddress={store.rtvAddress}
              step={step}
              merchandiseType={store.vendorDetails?.merchandiseType}
            />
          )}

          {store.upsAccountAddress.length === 0 && !store.rtvAddress.fedexAccountNumber && (
            <div>{_.NO_UPS_FEDEX_ACCT_FOUND}</div>
          )}
        </Col>
      </Row>
    );
  }

  return (
    <div id="ops-workflow-container">
      {state.rolePermissionStatus !== rolePermConsts.NONE &&
        roleName !== _.EXTERNAL_VENDOR_GENERIC &&
          roleName !== _.EXTERNAL_GENERIC_ADMIN && (
          <>
            {pageInfo.stepOrder === "17" && store.vendorDetails && (
              <UPSAddressModal
                vendorDetails={upsAddressInfo()}
                vendorProfileId={store.vendorDetails?.id}
                showModal={state.showUPSAddressModal}
                toggleModal={toggleUPSAddressModal}
                updateUPSAddresses={updateUPSAddresses}
              />
            )}
            <Row>
              <Col>
                <DisplayVendorStatus
                  text={getDisplayStatus(state.currentPageStatus)}
                />
                <Status
                  statusValue={pageInfo.genericStatus}
                  fieldType="radio"
                  radioGrp="generic"
                  style={showGrid("radio", disablePreDefinedNotes)}
                  statusName={pageInfo.statusName}
                  statusId={pageInfo.statusId}
                  onStatusChange={onStatusChange}
                  getSelectedStatus={getSelectedStatus}
                  disableElement={disableElement}
                />

                <Status
                  statusValue={pageInfo.definedStatus}
                  fieldType="checkbox"
                  radioGrp="defined"
                  style={showGrid("checkbox", disablePreDefinedNotes)}
                  statusName={pageInfo.statusName}
                  statusId={pageInfo.statusId}
                  onStatusChange={onStatusChange}
                  getSelectedStatus={getSelectedStatus}
                  disableElement={disablePreDefinedNotes || disableElement}
                />

                <TextArea
                  id="customComment"
                  placeHolderText={OPSConstants.CUSTOM_PLACEHOLDER_TEXT}
                  style="col-md-12"
                  noOfRows="4"
                  onChangeHandler={onSetCustomMsg}
                  disabled={disableElement}
                  value={state.customComment}
                  touched={state.isStatusChanged}
                />

                {pageInfo.stepOrder === "17" && store.vendorDetails && (
                  <UPSClosureDates
                    step={step}
                    holidayIdentifier={state.nationalHolidayIdentifier}
                    closureDateList={state.upsClosureDates}
                    holidayIdentifierHandler={onChangeHolidayIdentifier}
                    closureDateHandler={onChangeClosureDates}
                    closureDateDeleteHandler={onDeleteClosureDate}
                    disableElement={disableElement}
                  />
                )}
                <Row>
                  {pageInfo.stepOrder === "17" && (
                    <div>
                      <Button
                        className="button-primary-md auto-width"
                        style={{ padding: "0px 10px 0px 10px" }}
                        disabled={
                          disableElement ||
                          !(
                            getUserRolePermission(
                              getActiveOPSWorkflowPage(),
                              rolePermConsts.VMP_EDITUPSACCOUNT
                            ) === rolePermConsts.EDIT
                          )
                        }
                        onClick={toggleUPSAddressModal}
                      >
                        EDIT UPS ACCT(S)
                      </Button>
                    </div>
                  )}
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      className="button-later-md m-right-12"
                      disabled={
                        (!state.isClosureDateChanged &&
                          !state.isStatusChanged) ||
                        !(
                          getUserRolePermission(
                            getActiveOPSWorkflowPage(),
                            rolePermConsts.VMP_CANCEL
                          ) === rolePermConsts.EDIT
                        )
                      }
                      onClick={onCancel}
                    >
                      {OPSConstants.CANCEL}
                    </Button>
                    <Button
                      disabled={
                        getDisableStatus ||
                        !(
                          getUserRolePermission(
                            getActiveOPSWorkflowPage(),
                            rolePermConsts.VMP_UPDATE
                          ) === rolePermConsts.EDIT
                        )
                      }
                      className="button-primary-md"
                      onClick={updateStatusDetails}
                    >
                      {OPSConstants.UPDATE}
                    </Button>
                  </div>
                </Row>
                {state.validationMsg && (
                  <Row>
                    <p style={{ color: "red", marginLeft: "auto" }}>
                      {state.validationMsg}
                    </p>
                  </Row>
                )}
                {store.upsAccountAddress?.length > 0 && (
                  <SavedUPSAccount
                    addressList={store.upsAccountAddress}
                    step={step}
                    merchandiseType={store.vendorDetails?.merchandiseType}
                  />
                )}
              </Col>
            </Row>
          </>
        )}

      {pageInfo.stepOrder === "17" &&
      state.rolePermissionStatus === rolePermConsts.VIEW &&
      (roleName === _.EXTERNAL_VENDOR_GENERIC ||
        roleName === _.EXTERNAL_GENERIC_ADMIN) &&
      store.upsAccountAddress.length > 0 ? (
        <SavedUPSAccount
          addressList={store.upsAccountAddress}
          step={step}
          merchandiseType={store.vendorDetails?.merchandiseType}
        />
      ) : (
        pageInfo.stepOrder === "17" &&
        (roleName === _.EXTERNAL_VENDOR_GENERIC ||
          roleName === _.EXTERNAL_GENERIC_ADMIN) && (
          <p className="ml-3">There are currently no saved UPS Addresses</p>
        )
      )}
    </div>
  );
};

export default OPSWorkflow;
